import { connect } from 'react-redux'

import SelectedOffer from './index'

import { MultiProductState } from 'embed/reducers'
import { loanOfferSelectedSelector } from 'embed/selectors/rates'

const mapStateToProps = (state: MultiProductState) => ({
  offer: loanOfferSelectedSelector(state),
})

export default connect(mapStateToProps)(SelectedOffer)
